<div class=" bg-primary rounded-corners content-inner text-white" *ngIf="cart && cart?.items?.length > 0">
	<h5 class="font-weight-bold">Booking Summary</h5>
	<ng-container *ngIf="cart?.items && cart.items.length > 0">
		<div class="mb-2">Total</div>
		<h3 class="font-weight-bold">{{cart.cartTotal | currency: 'USD'}}</h3>

		<hr class="bg-white-ghosted">

		<div *ngFor="let item of cart?.items" class="mb-3">
			
			<div class="font-weight-bold mb-2">{{item.productUseName}}</div>

			<div class="ticket-details text-white-ghosted">
				<div class="font-weight-bold mb-2">{{item.date | date: 'M/d/yy'}}</div>
				<div class="font-weight-bold mb-2">{{item.productScheduleUseName}}</div>
				<div class="mb-2" *ngFor="let option of item.pricingOptions">{{option.quantity}} {{option.useName}} <span>({{option.displayPrice | currency: 'USD'}})</span></div>
			</div>

		</div>
	</ng-container>
	
</div>

<hr class="mt-4" *ngIf="cart && cart?.items?.length > 0">

<app-have-questions></app-have-questions>
<!-- <div class="">
	<div class="font-weight-bold mb-2">Have Questions?</div>
	<div class="mb-3 body-size">Find answers to our most commonly asked questions by visiting our <a [routerLink]="['/support/faq']" >FAQ page.</a></div>
	<div class="d-flex  body-size">
		<div class=""><a href="tel:14142313236" class="text-decoration-none"><fa-icon [icon]="['fas', 'phone-volume']" class="mr-1"></fa-icon> (414) 231-3236</a></div>
		<div class="d-block mx-2">|</div>
		<div class=""><a [routerLink]="['/support/contact-us']" class="text-decoration-none"><fa-icon [icon]="['fas', 'comments']" class="mr-1"></fa-icon> Contact Us</a></div>
	</div>
</div> -->
